module.exports = __webpack_public_path__ + "static/media/img-goal-8.7b4e0a3c.jpg";